import { Link } from 'react-router-dom';

import { domain, version } from 'mastodon/initial_state';

export const LinkFooter: React.FC<{
  multiColumn: boolean;
}> = ({ multiColumn }) => (
  <div className='link-footer'>
    <p>
      본 서버는{' '}
        크레페 한참 커미션의 공개 배포 버전을 사용하며, <a href='https://x.com/musim_boom' target='_blank' rel='noopener'>나뮤</a>의 지원입니다.
    </p>

    <p>
      <strong>{domain}</strong>{' '}
      <Link
        to='/privacy-policy'
        target={multiColumn ? '_blank' : undefined}
        rel='privacy-policy'
      >
        개인정보처리방침
      </Link>{' '}
      <a href='https://github.com/long-while/longwhile-mastodon' target='_blank' rel='noopener' className='version'>v{version}</a>
    </p>
  </div>
);
